export default __webpack_public_path__ + "static/media/MOSCOW.045732e6.jpg";